import PublicLayout from "@/components/public-layout";

export default function Faq() {
  return (
    <PublicLayout>
      <h1 className="font-bold">Często zadawane pytania</h1>
    </PublicLayout>
  );
}
